/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubmissionEstimateDiagnostic } from './SubmissionEstimateDiagnostic';
import {
    SubmissionEstimateDiagnosticFromJSON,
    SubmissionEstimateDiagnosticFromJSONTyped,
    SubmissionEstimateDiagnosticToJSON,
    SubmissionEstimateDiagnosticToJSONTyped,
} from './SubmissionEstimateDiagnostic';

/**
 * 
 * @export
 * @interface SubmissionProviderDiagnostic
 */
export interface SubmissionProviderDiagnostic {
    /**
     * 
     */
    status: string;
    /**
     * 
     */
    error?: string | null;
    /**
     * 
     */
    model?: string | null;
    /**
     * 
     */
    estimate?: SubmissionEstimateDiagnostic | null;
}

/**
 * Check if a given object implements the SubmissionProviderDiagnostic interface.
 */
export function instanceOfSubmissionProviderDiagnostic(value: object): value is SubmissionProviderDiagnostic {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function SubmissionProviderDiagnosticFromJSON(json: any): SubmissionProviderDiagnostic {
    return SubmissionProviderDiagnosticFromJSONTyped(json, false);
}

export function SubmissionProviderDiagnosticFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionProviderDiagnostic {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'error': json['error'] === undefined ? undefined : json['error'] === null ? null : json['error'],
        'model': json['model'] === undefined ? undefined : json['model'] === null ? null : json['model'],
        'estimate': json['estimate'] === undefined ? undefined : json['estimate'] === null ? null : SubmissionEstimateDiagnosticFromJSON(json['estimate']),
    };
}

export function SubmissionProviderDiagnosticToJSON(json: any): SubmissionProviderDiagnostic {
    return SubmissionProviderDiagnosticToJSONTyped(json, false);
}

export function SubmissionProviderDiagnosticToJSONTyped(value?: SubmissionProviderDiagnostic | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'error': value['error'],
        'model': value['model'],
        'estimate': SubmissionEstimateDiagnosticToJSON(value['estimate']),
    };
}

